import styled from 'styled-components'

import { Color, IColorScore } from '../hooks/use-game'
import { getHexagonImage, getStarImage } from '../utils/color'
import NumberInput from './number-input'

interface IProps {
  color: Color
  value: IColorScore
  setValue: (type: keyof IColorScore, value: number) => void
}

export default function ColorScore({ color, value, setValue }: IProps) {
  return (
    <Container>
      <div className="icons-container">
        <img className="star" alt="" src={getStarImage(color)} />
        <img className="hexagon" alt="" src={getHexagonImage(color)} />
      </div>
      <div className="inputs-container">
        <NumberInput setValue={(value: number) => setValue('multiplier', value)} value={value.multiplier} />
        <p>x</p>
        <NumberInput setValue={(value: number) => setValue('count', value)} value={value.count} />
      </div>
      <p>= {value.multiplier * value.count}</p>
    </Container>
  )
}

const Container = styled.div`
  align-items: center;
  border-bottom: solid 1px #bc9b33;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 15.5%;
  justify-content: center;
  width: 100%;

  .icons-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 24px;
    justify-content: center;
    width: 100%;

    & > img {
      height: auto;
      width: 16px;
    }
  }

  .inputs-container {
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 4px;
    justify-content: center;
    width: 100%;

    & > p {
      color: #000000;
      font-size: 16px;
    }
  }

  & > p {
    color: #000000;
    font-size: 20px;
    font-weight: bold;
    margin-top: 8px;
  }
`
